module.exports = __webpack_public_path__ + "media/images/athletes/3414-4526922be7350e70828e158f1b054b59.png";